import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ServicesSection = styled.section`
  padding: 60px 0;
  background: #FFFDF7;
`;

const ServicesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 40px;
  color: #2C1810;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 24px;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled(Link)`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(139, 105, 20, 0.06);
  border: 1px solid rgba(218, 165, 32, 0.08);
  padding: 24px;
  text-align: center;
  transition: all 0.3s;
  text-decoration: none;
  position: relative;
  animation: ${fadeIn} 0.6s ease-out both;
  animation-delay: ${p => p.$delay || '0s'};

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(218, 165, 32, 0.12);
    border-color: rgba(218, 165, 32, 0.2);
  }
`;

const ServiceIcon = styled.div`
  width: 72px;
  height: 72px;
  background: ${p => p.$bg || 'linear-gradient(135deg, #FFF8E7, #FFE8B0)'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 1.8rem;
`;

const ServiceTitle = styled.h3`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.15rem;
  margin-bottom: 8px;
  color: #2C1810;
`;

const ServiceDesc = styled.p`
  color: #9B8B7A;
  font-size: 0.82rem;
  line-height: 1.5;
  margin: 0;
`;

const Copyright = styled.div`
  text-align: center;
  padding: 20px 0;
  color: #9B8B7A;
  font-size: 0.85rem;
`;

const HomePage = () => {
  return (
    <>
      <ServicesSection>
        <ServicesContainer>
          <SectionTitle>Our Services</SectionTitle>
          <ServicesGrid>
            <ServiceCard to="/talk-to-astrologer" $delay="0.1s">
              <ServiceIcon $bg="linear-gradient(135deg, #E8F5E9, #C8E6C9)">📞</ServiceIcon>
              <ServiceTitle>Talk to Astrologer</ServiceTitle>
              <ServiceDesc>Instant voice & video calls with expert Vedic astrologers</ServiceDesc>
            </ServiceCard>
            <ServiceCard to="/consultation" $delay="0.2s">
              <ServiceIcon $bg="linear-gradient(135deg, #E3F2FD, #BBDEFB)">📅</ServiceIcon>
              <ServiceTitle>Book Consultation</ServiceTitle>
              <ServiceDesc>Schedule tarot, palm reading, reiki & more</ServiceDesc>
            </ServiceCard>
            <ServiceCard to="/vedic-tools" $delay="0.3s">
              <ServiceIcon $bg="linear-gradient(135deg, #FFF8E7, #FFE8B0)">🪷</ServiceIcon>
              <ServiceTitle>Vedic Tools</ServiceTitle>
              <ServiceDesc>Kundli, Panchangam, Muhurta & 10+ free tools</ServiceDesc>
            </ServiceCard>
          </ServicesGrid>
        </ServicesContainer>
      </ServicesSection>

      <Copyright>
        Copyright &copy; 2025 JyotishSastra. All Rights Reserved
      </Copyright>
    </>
  );
};

export default HomePage;
